import { AppDispatch } from '../store/store';
import Cookies from 'js-cookie';
import { logout, setPacienteData, setPacienteLoading, setPacienteError } from './authSlice';
import { getPacienteAuthMe } from '../api/pacientesAuthMe.api';
import axios from 'axios';

export const performLogout = () => (dispatch: AppDispatch) => {
  Cookies.remove('accessToken');
  Cookies.remove('refreshToken');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('urlToken');
  
  dispatch(logout());
};

// Nueva acción para cargar datos del paciente autenticado
export const fetchPacienteAuthData = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(setPacienteLoading());
    const pacienteAuthData = await getPacienteAuthMe();
    dispatch(setPacienteData(pacienteAuthData));
    return pacienteAuthData;
  } catch (error) {
    // Solo hacer log del error, NO repetir el console.error
    if (axios.isAxiosError(error)) {
      const statusCode = error.response?.status;
      const errorMessage = error.response?.data?.message || error.message;
      
      // Si es 404, el paciente no tiene datos - no es un error crítico
      if (statusCode === 404) {
        console.log('ℹ️ Paciente sin datos registrados (404)');
      } else {
        console.error(`Error ${statusCode} al obtener datos del paciente:`, errorMessage);
      }
      
      dispatch(setPacienteError(errorMessage || 'Error desconocido'));
    } else {
      const errorMessage = error instanceof Error ? error.message : 'Error desconocido';
      dispatch(setPacienteError(errorMessage));
    }
    
    return null;
  }
};
